import React from "react";

import GeneralRichText from "./GeneralRichText";
import Author from "@components/Author";
import Title from "./Title";
import Text from "./Text";
import DynamicLink from "./DynamicLink";
import { colors } from "@utils/styles";

export default function ArticleBody(props) {
	const { fields, articleAccessClass } = props;
	return (
		<div>
			<div className={`blog-article-body ${articleAccessClass} relative`}>
				{fields.bodyText && <GeneralRichText content={fields.bodyText} />}
			</div>
			{fields?.author?.length && (
				<footer>
					<Author authors={fields.author} />

					<Text
						size="12"
						text={
							<>
								Interested in sharing leadership insights?{" "}
								<DynamicLink text="Contribute" href="/publications/contribute" color={colors.green} />
							</>
						}
					/>
					<br />
				</footer>
			)}

			<style global jsx>{`
				.clip-article {
					height: 500px;
					overflow: hidden;
				}

				.blog-article-body h1 {
					font-size: 56px;
					line-height: 60px;
					margin-top: 23px !important;
					margin-bottom: 18px !important;
					color: ${colors.dark} !important;
					font-family: "Athelas";
					font-weight: bold;
				}
				.blog-article-body h2 {
					margin-top: 36px !important;
					margin-bottom: 15px !important;
					font-size: 36px !important;
					font-weight: 600;
					color: #444444 !important;
					line-height: 30px;
				}

				.blog-article-body h2 + p {
					margin-top: 0.5em !important;
				}

				.blog-article-body p {
					/* border: 3px solid red; */
					color: ${colors["blogFont"]} !important;
					font-size: 17px !important;
					margin: 0px !important;
					margin-top: 28px !important;
					font-family: "Open Sans", serif !important;
					line-height: 32px !important;
				}
				.blog-article-body a > b i {
					color: #32a8a4 !important;
					font-weight: bold;
					text-decoration: none;
				}

				.MsoTableGrid {
					background: white;
				}

				/* wide-caption-header */
				.wide-caption-header {
					margin: 10px 0px 10px -10px;
					padding: 20px 20px 20px 20px;
					border-top: 2px solid #d41a20;
					border-bottom: 2px solid #d41a20;
					font-family: "Athelas", Georgia, serif;
				}

				.wide-caption-header img {
					align-self: center;
				}
				.wide-caption-header h4 {
					font-size: 1.5em;
					font-family: "Athelas", Georgia, serif;
					color: #444444;
				}
				.wide-caption-header strong {
					color: #444444;
				}

				/* text-caption */

				.text-caption {
					border-top: #d41a20 3px solid;
					border-bottom: #d41a20 3px solid;
					margin: 10px 20px 10px -10px;
					float: left;
					padding: 20px 20px 10px 10px;
					width: 310px;
					font-family: "Athelas", serif !important;
				}
				.text-caption h4 {
					color: ${colors["dark"]};
				}

				.text-caption p {
					font-size: 15px !important;
					color: ${colors["red"]};
					line-height: 1.5em !important;

					font-family: "Athelas", serif !important;
				}

				.text-caption h4 {
					font-size: 1.5em;
					font-family: "Athelas", Georgia, serif;
					color: #444444;
				}

				.mug-caption {
					margin: 10px 20px 10px -10px;
					float: left;
					padding: 20px 20px 0px 20px;
					width: 220px;
					font-family: "Open Sans", sans-serif !important;
					font-size: 0.8em;
				}

				.mug-caption p {
					color: #444444;
				}

				.quote-box {
					padding: 20px 20px 10px;
					margin: 20px 20px 10px -10px;
					border-radius: 0px;
					background-color: #245a91;
					color: white !important;
					width: 300px;
					float: left;
				}

				.quote-box p {
					color: #fff !important;
					padding-left: 10px;
					font-size: 1.4em;
					line-height: 1.2em;
					margin-top: 0 !important;
				}

				.quote-box hr {
					border: 0;
					height: 0;
					border-top: 0px solid rgba(0, 0, 0, 0.1) !important;
					border-bottom: 2px solid rgba(255, 255, 255, 1) !important;
				}

				.quote-box .quotation-mark {
					display: block;
					font-weight: 700;
					font-size: 60px;
					color: white;
					font-family: "Athelas", serif;
					float: left;
					margin-right: 20px;
				}

				.qa {
					padding: 15px 20px 15px 0px;
					margin-left: -10px;
				}
				.blog-article-container .q {
					display: block;
					background-color: #245a91;
					color: #fff !important;
					padding: 15px 15px;
					font-family: "Open Sans", sans-serif !important;
					font-weight: 700;
					margin-bottom: 0px;
					display: flex;
					align-items: center;
				}
				.question {
					color: ${colors.yellow};

					font-size: 2em;
					display: block;
					float: left;
					padding: 0px 20px 0px 0px;
				}
				.question:after {
					content: ":";
				}
				.a {
					display: block;
					background-color: #fff;
					color: #666;
					padding: 15px 15px 15px 20px;
					font-weight: normal;
					margin-top: 0px;
				}
				.answer {
					font-size: 5em;
					color: #d41a20;
					float: left;
					padding: 0.1em 0.2em;
					display: flex;
					align-items: center;
				}
				.answer:after {
					content: ":";
				}

				@media screen and (min-width: 992px) {
					.mug-caption,
					.text-caption,
					.quote-box {
						margin: 10px 20px 10px -100px;
					}
					.qa {
						margin-left: -100px;
					}
					.wide-caption-header {
						margin: 10px 0px 10px -100px;
					}
				}
			`}</style>
		</div>
	);
}
